import React from "react";
import { createRoot } from 'react-dom/client';
import { HelmetProvider } from 'react-helmet-async';
import App from "./App";
import Modal from "react-modal";

Modal.setAppElement("#root");

const initializeAnalytics = () => {
    import("./helpers/analytics")
        .then(({ default: initialize }) => initialize())
        .catch((error) => console.error("Unable to initialize analytics:", error));
};

if ("requestIdleCallback" in window) {
    window.requestIdleCallback(initializeAnalytics, { timeout: 3000 });
} else {
    window.setTimeout(initializeAnalytics, 1500);
}

const container = document.getElementById('root');
const root = createRoot(container);
root.render(
    <HelmetProvider>
        <App />
    </HelmetProvider>
);